// Blueprint hover effect: technical grid + measurement marks behind the knob,
// with handwritten dimension notes pulled from each product's technical specs.
export default function BlueprintOverlay({ product }) {
  const { height, topWidth, bottomWidth } = product.dims;
  return (
    <div className="blueprint-layer" aria-hidden="true" data-testid={`card-blueprint-${product.slug}`}>
      <div className="blueprint-grid" />
      <div className="blueprint-ticks blueprint-ticks--top" />
      <div className="blueprint-ticks blueprint-ticks--bottom" />
      <div className="blueprint-ticks blueprint-ticks--left" />
      <div className="blueprint-ticks blueprint-ticks--right" />
      <span className="blueprint-cross blueprint-cross--v" />
      <span className="blueprint-cross blueprint-cross--h" />
      <span className="blueprint-ring blueprint-ring--inner" />
      <span className="blueprint-ring blueprint-ring--outer" />
      <span className="blueprint-mark blueprint-mark--tl" />
      <span className="blueprint-mark blueprint-mark--tr" />
      <span className="blueprint-mark blueprint-mark--bl" />
      <span className="blueprint-mark blueprint-mark--br" />
      <svg className="blueprint-sketch" viewBox="0 0 400 220" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
        <path className="pencil-center" d="M 200 8 C 199.2 70, 200.8 150, 199.6 212" />
        <path className="pencil-center" d="M 8 104 C 130 103.2, 270 104.8, 392 103.6" />
        <path className="dim" pathLength="1" d="M 122 184 C 166 182.4, 234 185.2, 278 183.2" />
        <path className="dim" pathLength="1" d="M 119 178 L 125 189" />
        <path className="dim" pathLength="1" d="M 281 178 L 275 189" />
        <path className="dim" pathLength="1" d="M 130 180 L 122.5 183.8 L 130 187.6" />
        <path className="dim" pathLength="1" d="M 270 179.5 L 277.8 183.2 L 270 187" />
        <path className="dim" pathLength="1" d="M 314 58 C 312.6 92, 315.2 126, 313.6 162" />
        <path className="dim" pathLength="1" d="M 309 55 L 319 61" />
        <path className="dim" pathLength="1" d="M 309 165 L 319 159" />
        <path className="dim" pathLength="1" d="M 310 66 L 314 58.4 L 318 66" />
        <path className="dim" pathLength="1" d="M 310 154 L 313.8 161.8 L 318 154" />
        <path className="dim" pathLength="1" d="M 94 57 C 120 64, 148 76, 170 87" />
        <path className="dim" pathLength="1" d="M 162.5 83.5 L 170.4 87.4 L 164.5 91.5" />
        <g transform="rotate(-2 200 200)">
          <text x="200" y="200" textAnchor="middle">{`W ${bottomWidth}`}</text>
        </g>
        <g transform="rotate(-3 322 50)">
          <text x="322" y="50">{`H ${height}`}</text>
        </g>
        <path className="dim" pathLength="1" d="M 290 199 C 276 172, 258 128, 240 90" />
        <path className="dim" pathLength="1" d="M 238.6 97.9 L 239.8 90.2 L 247 94" />
        <g transform="rotate(-2 288 204)">
          <text x="288" y="204">lock ✓</text>
        </g>
        {product.mechanism.includes('Locking') && (
          <>
            <path className="dim" pathLength="1" d="M 118 190 C 133 175, 152 156, 168 140" />
            <path className="dim" pathLength="1" d="M 161 143.5 L 168.2 139.8 L 169.5 147" />
            <g transform="rotate(-2 64 204)">
              <text x="64" y="204" data-testid={`blueprint-addl-lock-${product.slug}`}>add'l lock ✓</text>
            </g>
          </>
        )}
        <g transform="rotate(-2.5 56 50)">
          <text x="56" y="50">{`top ${topWidth}`}</text>
        </g>
      </svg>
    </div>
  );
}
